<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-20">
    <Teleport
      defer
      to="#portal-modal-header-target"
    >
      {{ formatMessageDate(message.deliveredDate) }}
    </Teleport>
    <div
      v-if="message.inboxMessage.primaryImageUri"
      class="cf-image-container cf-image-container--bleed cf-image-container--large"
    >
      <img
        class="cf-image cf-image--cover"
        :src="message.inboxMessage.primaryImageUri"
        :alt="`${message.inboxMessage.title} image`"
        data-test-id="inbox-message-image"
        onerror="this.src='/images/image-not-found.png';"
      >
    </div>

    <div class="cf-flex cf-flex--column cf-flex--gap-16">
      <h2
        class="cf-title cf-title--1 cf-title--medium cf-title--center"
        data-test-id="inbox-message-title"
      >
        {{ message.inboxMessage.title }}
      </h2>

      <p
        data-test-id="inbox-message-body"
        class="cf-subtitle cf-subtitle--1 cf-subtitle--center cf-subtitle--light-gray"
      >
        {{ message.inboxMessage.bodyContent }}
      </p>
    </div>

    <button
      v-if="message.inboxMessage.ctaContent && message.inboxMessage.ctaUri"
      class="cf-button cf-button--primary cf-button--lg"
      type="button"
      data-test-id="inbox-message-cta"
      @click="ctaHandler(message.inboxMessage.ctaUri)"
    >
      {{ message.inboxMessage.ctaContent }}
    </button>

    <div class="cf-flex cf-flex--row cf-flex--justify-end spacing">
      <button
        type="button"
        class="cf-button cf-button--danger-alt cf-button--sm cf-no-border"
        data-test-id="inbox-message-delete"
        @click="deleteMessage"
      >
        Delete Message
      </button>
    </div>
  </div>
</template>

<script>
  import moment from 'moment-timezone';

  import calculateDeviceTimezone from '@/helpers/calculate-device-timezone';

  export default {
    name: 'InboxMessage',

    props: {
      message: {
        type: Object,
        required: true
      },

      messageId: {
        type: String,
        required: true
      },

      onDelete: {
        type: Function,
        required: true
      }
    },

    methods: {
      closeMessage() {
        this.$closeModal('inboxMessage');
      },

      deleteMessage() {
        this.onDelete();
        this.$closeModal('inboxMessage');
      },

      formatRoute(link) {
        const url = new URL(link);
        const searchParams = new URLSearchParams(url.search);
        const query = {};

        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of searchParams.entries()) {
          query[key] = value;
        }

        return {
          path: url.pathname,
          query
        };
      },

      ctaHandler(ctaUri) {
        if (ctaUri) {
          try {
            const route = this.formatRoute(ctaUri);
            this.$router.push(route);
            this.$closeModal('inboxMessage');
          }
          catch (error) {
            // If URL parsing fails, treat as external link
            window.open(ctaUri, '_blank');
            this.$closeModal('inboxMessage');
          }
        }
      },

      formatMessageDate(deliveredDate) {
        if (!deliveredDate) return '';

        const timezone = calculateDeviceTimezone();
        const messageDate = moment(deliveredDate).tz(timezone);
        const now = moment().tz(timezone);

        // If today, show time
        if (messageDate.isSame(now, 'day')) {
          return messageDate.format('h:mm A');
        }

        // If this year, show "Feb 25" format
        if (messageDate.isSame(now, 'year')) {
          return messageDate.format('MMM D');
        }

        // Otherwise show MM/DD/YY format
        return messageDate.format('MM/DD/YY');
      }
    }
  };
</script>

<style lang="scss" scoped>
  .cf-image-container--large {
    height: 200px;
    border-radius: 8px;
    overflow: hidden;

    .cf-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .cf-title--center {
    text-align: center;
  }

  .cf-subtitle--center {
    text-align: center;
  }
</style>
